import React from "react";
import { Typography } from "best-common-react";

const TodaysTicketsWarningText = () => {
  return (
    <>
      <Typography>
        Tickets listed under Today's Tickets reflect remaining inventory for the game, which may include unclaimed
        tickets allotted for business purposes. Please note:
        <ul>
          <li>These tickets will not be used to fulfill personal employee requests already submitted.</li>
          <li>
            If you have already received tickets for today’s game through a prior request, you are not eligible to claim
            additional tickets for the same date.
          </li>
          <li>Employees may only request up to 4 tickets to 1 club, per day.</li>
        </ul>
        This system is designed to give as many employees as possible the chance to enjoy a game.
      </Typography>
    </>
  );
};

export default TodaysTicketsWarningText;
